<template>
  <div class="course-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>参加培训任务</el-breadcrumb-item>
    </el-breadcrumb>
    <PublicSearch class="user-search" :searchData="searchData"
      @onSearch="() => { pageInfo.currentPage = 1; getData() }"></PublicSearch>
    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">
      <template #planName="item">
        <div class="col-29f cs-pit" @click="handleAction(1, item)">{{ item.row.planName }}</div>
      </template>
      <template #passSign="item">{{ item.row.passSign ? '已完成' : '未完成' }}</template>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import myImportDialog from '@/components/myImportDialog.vue';
import api from '../../api/participationTrain/index';
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    myImportDialog
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '任务名称：', prop: 'planName', type: 'input', placeholder: '请输入任务名称' }
        ],
        searchQuery: {} //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '任务名称', slot: 'planName' },
        { label: '任务类别', prop: 'planCategoryText' },
        { label: '所属级别', prop: 'levelText' },
        { label: '完成情况', slot: 'passSign' }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 } //  分页参数
    }
  },
  created () {
    this.getDictionary();
    this.getData();
  },
  methods: {
    getDictionary () {
    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize
      };
      const res = await api.trainPlanMyPage(Object.assign(this.searchData.searchQuery, params));
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      switch (index) {
        case 1:
          await this.$router.push({
            path: '/participation/course',
            query: { planId: data.row.planId }
          })
          break;
      }
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    }
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;

  .user-search {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/participationTrain/index.vue